import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const PROTEIN_ENTITY_STRUCTURE_PREDICTION_QUERY = gql`
  query ProteinEntityStructurePredictionQuery($proteinId: StrictString!, $versionId: StrictString!)
  @skipAudit
  @engComponent(name: ANTIBODIES) {
    bioentity(id: $proteinId) {
      ... on BasicFolderItemNode {
        id
        folder {
          id
        }
      }
      ...InaccessibleInfoGraphQL
    }
    antibody(antibodyId: $proteinId) {
      ... on AntibodyNode {
        id
        version(versionId: $versionId) {
          ... on AntibodyVersionNode {
            id
            chains {
              refs
              entity {
                ... on ProteinNode {
                  id
                  experimentalCurrentVersion {
                    dbId
                    aminoAcids
                  }
                  permissions {
                    readable
                    structurePredictionEditable
                  }
                }
                # AaSequenceNode is ProteinNode's replacement name and carries identical fields.
                # Which one the server sends changes at the canonical flip, so both branches are
                # needed until the old name is removed (BNCH-169122).
                ... on AaSequenceNode {
                  id
                  experimentalCurrentVersion {
                    dbId
                    aminoAcids
                  }
                  permissions {
                    readable
                    structurePredictionEditable
                  }
                }
                ...InaccessibleInfoGraphQL
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
